import { List } from "immutable";
import { createSelector } from "reselect";

import { PATH_TO_LOCATIONS_STATE } from "../consts";
import LocationsStateSlice from "../models/LocationsStateSlice";
import Location from "../models/state/locations/location/Location";
import { getLocationsSlice } from "./state";
import * as locationsSelectors from "./state/locations";
import * as locationSelectors from "./state/locations/location";

type State = any;

export const getLocationsStateSlice = (state: State): LocationsStateSlice =>
  state.get(PATH_TO_LOCATIONS_STATE);

const composedGetLocationsSlice = (state: State) =>
  getLocationsSlice(getLocationsStateSlice(state));

export const getLocations = composedGetLocationsSlice;

export const getLocation = (state: State, locationId: string) =>
  locationsSelectors.getLocation(composedGetLocationsSlice(state), locationId);

const emptyList = List<Location | undefined>();

export const makeGetRandomLocationsImageURLs = (number: number) =>
  createSelector(composedGetLocationsSlice, locationsMap => {
    let locations = locationsMap.toList();
    let randomLocations = emptyList;

    while (randomLocations.size < number) {
      const index = Math.floor(locations.size * Math.random());
      randomLocations = randomLocations.push(locations.get(index));
      locations = locations.remove(index);
    }

    return randomLocations.map(
      location => locationSelectors.getImageUrl(location!) as string
    );
  });

// location selectors

export const getLocationId = (state: State, locationId: string) =>
  locationsSelectors.getLocationId(
    composedGetLocationsSlice(state),
    locationId
  );

export const getLocationName = (state: State, locationId: string) =>
  locationsSelectors.getLocationName(
    composedGetLocationsSlice(state),
    locationId
  );

export const getLocationCountryName = (state: State, locationId: string) =>
  locationsSelectors.getLocationCountryName(
    composedGetLocationsSlice(state),
    locationId
  );

export const getLocationImageUrl = (state: State, locationId: string) =>
  locationsSelectors.getLocationImageUrl(
    composedGetLocationsSlice(state),
    locationId
  );

export const getLocationLatitude = (state: State, locationId: string) =>
  locationsSelectors.getLocationLatitude(
    composedGetLocationsSlice(state),
    locationId
  );

export const getLocationLongitude = (state: State, locationId: string) =>
  locationsSelectors.getLocationLongitude(
    composedGetLocationsSlice(state),
    locationId
  );
